import { render, staticRenderFns } from "./AssignColourButton.vue?vue&type=template&id=caebdf6a&"
import script from "./AssignColourButton.vue?vue&type=script&lang=js&"
export * from "./AssignColourButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports